<template>
 	<b-container v-if="$can('view-categories') || $can('view-all')" fluid>
        <b-row class="page-title">
            <b-container fluid>
                <b-row>
                    <b-col>
                        <h3>Categories</h3>
                    </b-col>
                    <b-col class="buttons-create text-right">
                        <b-button variant="outline-primary" size="sm" @click="openModal('create-category')">New Category</b-button>
                        <!-- <b-button variant="outline-primary" size="sm" @click="openModal('import-update')">Import / Update</b-button> -->
                        <b-button variant="outline-primary" size="sm" @click="openModal('export-columns')">Export</b-button>
                    </b-col>
                </b-row>
                <hr>
            </b-container>
        </b-row>

        <b-row>
            <b-container fluid>
                <b-row>
                    <b-col cols="3">
                        <b-form-group>
                          <b-input-group size="sm">
                            <b-form-input
                              v-model="tables.categories.filter"
                              type="search"
                              id="filterInput"
                              placeholder="Type to Search"
                              debounce="500"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button :disabled="!tables.categories.filter" @click="tables.categories.filter = ''">Clear</b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col class="text-center" cols="3">
                        <b-button v-if="tables.categories.hasQueryClicks" variant="danger" size="sm" @click="clearQueryClicks">Clear Filters</b-button>
                    </b-col>

                    <b-col cols="5" />

                    <b-col cols="1">
                        <b-form-group>
                          <b-form-select
                            v-model="tables.categories.perPage"
                            id="perPageSelect"
                            size="sm"
                            :options="tables.categories.pageOptions"
                          ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="row-categories-table">
                    <b-container fluid>
                        <b-table
                            v-if="tables.categories.ready"
                            :key="tables.categories.key"
                            class="categories-table"
                            responsive bordered striped
                            hover no-border-collapse
                            sticky-header="calc(100vh - 250px)"
                            head-variant="light"
                            :items="tables.categories.items"
                            :fields="visibleFields"
                            :sort-by="tables.categories.sortBy"
                            :sort-desc="tables.categories.sortDesc"
                            :per-page="tables.categories.perPage"
                            :current-page="tables.categories.currentPage"
                            :filter="tables.categories.filter"
                            @filtered="onFiltered"
                            :busy="tables.categories.isBusy"
                        >

                            <template v-slot:table-busy>
                                <div class="text-center text-default my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>

                            <template v-slot:cell(assigned)="row">
                                {{ row.item.assigned.length }}
                            </template>

                            <template v-slot:cell(actions)="row">
                                <b-container class="actions-icons" fluid>
                                    <b-row>
                                        <!-- <b-col>
                                            <b-link @click=""><i class="far fa-check-square"></i></b-link>
                                        </b-col> -->
                                        <b-col>
                                            <b-link v-if="row.item.name != 'Uncategorized'" @click="openModal('edit-category', row.item)"><i class="fas fa-edit"></i></b-link>
                                        </b-col>
                                        <!-- <b-col v-if="$can('view-all')">
                                            <b-link v-if="row.item.name != 'Uncategorized'" class="icon-danger"><i class="fas fa-trash-alt"></i></b-link>
                                        </b-col> -->
                                    </b-row>
                                </b-container>
                            </template>
                        </b-table>
                    </b-container>
                </b-row>

                <b-row>
                    <b-col cols="6">
                        {{ pageTotals }}
                    </b-col>

                    <b-col cols="6" class="my-1">
                        <b-pagination
                          v-model="tables.categories.currentPage"
                          :total-rows="tables.categories.totalRows"
                          :per-page="tables.categories.perPage"
                          align="fill"
                          size="sm"
                          class="my-0"
                        ></b-pagination>
                    </b-col>
                </b-row>
            </b-container>
        </b-row>

        <modal-create-category
            v-if="modals['create-category'].active"
            @getCategories="getCategories"
        />

        <modal-edit-category
            v-if="modals['edit-category'].active"
            :row="modals['edit-category'].row"
            @getCategories="getCategories"
        />

        <modal-export-columns
            v-if="modals['export-columns'].active"
            :fields="modals['export-columns'].fields"
            :ignores="modals['export-columns'].ignores"
            @exportExcel="exportExcel"
        />
    </b-container>
</template>

<script>
    import ModalCreateCategory from './modals/CreateCategory'
    import ModalEditCategory from './modals/EditCategory'
    import ModalExportColumns from '../../common/modals/ExportColumns'
    import tableColumnPreferences from '../../../../mixins/tableColumnPreferences'
 	export default {
    	name: 'categories',

        mixins: [tableColumnPreferences],

        metaInfo() {
            return {
                title: 'Categories',
            }
        },

    	components: {
              'modal-create-category': ModalCreateCategory,
              'modal-edit-category': ModalEditCategory,
              'modal-export-columns': ModalExportColumns
    	},
        data() {
            return {
                modals: {
                    'create-category': {
                        active: 0
                    },

                    'edit-category': {
                        active: 0,
                        row: []
                    },

                    'export-columns': {
                        active: 0,
                        fields: [],
                        ignores: ['actions']
                    },
                },
                tables: {
                    categories: {
                        filteredItems: [],
                        isBusy: false,
                        totalRows: 1,
                        currentPage: 1,
                        perPage: 20,
                        pageOptions: [20, 50, 100, 500],
                        sortBy: 'date_completed',
                        sortDesc: true,
                        // sortDirection: 'asc',
                        filter: null,
                        filterCat: '',
                        key: 1,
                        userFields: [],
                        fields: [
                            {
                                key: 'id',
                                label: 'ID',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'name',
                                label: 'Name',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'assigned',
                                label: 'Item Count',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'actions',
                                label: '',
                                thClass: 'categories-table-style-actions',
                                visible: 1
                            }
                        ],

                        items: [],
                        ready: 0
                    },
                },

                exports: {
                    cols: []
                }
            }
        },
        methods: {
            exportExcel(cols, keys) {
                let url = 'api/exports/generateexport'
                axios.post(url, {
                    rows: this.objFilter(this.tables.categories.filteredItems, keys),
                    table: 'categories',
                    cols: cols,
                    keys: keys
                },
                {
                    responseType: 'blob'
                })
                .then((res) => {
                    this.forceFileDownload(res)
                }, () => {
                    this.has_error = true
                })
            },

            forceFileDownload(response){
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Categories_Export_File_' + +new Date() + '.xlsx') //or any other extension
                document.body.appendChild(link)
                link.click()

                this.showAlertBox('success', 'File Generated', 'Categories export file generated successfully!')
            },

            openModal(modalName, row, extra) {
                let prefix = 'modal-inventory-categories-'
                switch (modalName) {
                    case 'create-category':
                        this.modals[modalName].active = 1

                        break
                    case 'edit-category':
                        this.modals[modalName].active = 1
                        this.modals[modalName].row = Object.assign({}, row)
                        break
                    case 'export-columns':
                        this.modals[modalName].active = 1

                        this.modals[modalName].fields = JSON.parse(JSON.stringify(this.tables.categories.fields.filter(e => !this.modals[modalName].ignores.includes(e.key))))

                        break
                }

                if (modalName == 'adjust-columns' || modalName == 'export-columns') {
                    prefix = 'modal-common-'
                }

                this.$nextTick(() => {
                    this.$bvModal.show(prefix + modalName)
                })
            },

            toggleBusy() {
                this.tables.categories.isBusy = !this.tables.categories.isBusy
            },

            getCategories(silent) {
                this.tables.categories.ready = 0
                this.tables.categories.filter = this.rememberedCategory.filter
                this.tables.categories.perPage = this.rememberedCategory.perPage

                if (!silent) {
                    this.toggleBusy()
                }

                let url = 'api/inventory/categories/getcategories'
                axios.get(url, {})
                .then((res) => {
                    this.tables.categories.items = res.data.categories
                    if (!this.tables.categories.filteredItems.length) {
                        this.tables.categories.filteredItems = res.data.categories
                    }
                    this.tables.categories.totalRows = this.tables.categories.items.length
                    this.tables.categories.ready = 1

                    if (!silent) {
                        this.toggleBusy()
                    }

                    this.setLastState()
                }, () => {
                    this.has_error = true
                })
            },

            onFiltered(filteredItems) {
                this.tables.categories.totalRows = filteredItems.length
                this.tables.categories.currentPage = 1
                this.tables.categories.filteredItems = filteredItems
            },

            setLastState() {
                this.$nextTick(() => {
                    if (this.rememberedCategory.name && this.rememberedCategory.page) {
                        this.tables.categories.currentPage = this.rememberedCategory.page
                        this.$nextTick(() => {
                            this.$refs[this.rememberedCategory.name].$el.scrollIntoView()
                        })
                    }
                })
            },

            getColSaves() {
                let url = 'api/remembertable/getcolsaves/categories'
                axios.get(url, {})
                .then((res) => {
                    if (res.data.status == 'success') {
                        if (res.data.colSaves) {
                            const merged = this.mergeColSaves(this.tables.categories.fields, res.data.colSaves.column_array)
                            if (merged) {
                                this.tables.categories.userFields = merged
                            }
                        }

                        this.getCategories()
                    }
                }, () => {
                    this.has_error = true
                })
            },

            saveColSaves(fields) {
                const normalized = this.normalizeColumnOrder(fields)
                this.tables.categories.userFields = normalized
                let url = 'api/remembertable/savecolsaves'
                axios.post(url, {
                    area: 'categories',
                    fields: this.formatColSavesPayload(normalized)
                })
                .then((res) => {
                    this.forceRerender()
                }, () => {
                    this.has_error = true
                })
            },

            forceRerender() {
                this.tables.categories.ready = 0
                let tempFields = this.tables.categories.fields
                this.tables.categories.fields = []
                this.$nextTick(() => {
                    this.tables.categories.fields = tempFields
                    this.tables.categories.ready = 1
                })
            }
        },

    	computed: {
	    	sortOptions() {
                // Create an options list from our fields
                return this.tables.categories.fields
                    .filter(f => f.sortable)
                    .map(f => {
                        return { text: f.label, value: f.key }
                    })
            },

            pageTotals() {
                let totalRows = this.tables.categories.totalRows
                let currentPage = this.tables.categories.currentPage
                let perPage = this.tables.categories.perPage

                let from
                let to

                if (perPage > totalRows) {
                    from = 1
                    to = totalRows
                } else {
                    to = perPage * currentPage
                    from = to - perPage + 1
                }

                return 'Showing ' + from + ' to ' + to + ' of ' + this.tables.categories.totalRows + ' rows'
            },

            visibleFields() {
                return this.buildVisibleFields(this.tables.categories.fields, this.tables.categories.userFields)
            }
	    },

	    mounted() {
            this.getColSaves()

            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                switch (modalId) {
                    case 'modal-inventory-categories-create-category':
                        this.modals['create-category'].active = 0

                        break
                    case 'modal-inventory-categories-edit-category':
                        this.modals['edit-category'].active = 0
                        this.modals['edit-category'].row = []

                        break
                    case 'modal-common-export-columns':
                        this.modals['export-columns'].active = 0
                        this.modals['export-columns'].fields = []

                        break
                }
            })

            // // pusher
            // Echo.channel('table-categories-updated')
            //     .listen('TableCategoriesUpdated', (e) => {
            //         this.getCategories(1)
            // })
	    }
  }
</script>
<style lang="scss">
    .vue-treeselect__control {
        // height: calc(1.5em + 0.5rem + 2px);
        // padding-top: 0.25rem;
        // padding-bottom: 0.25rem;
        // padding-left: 0.5rem;
        font-size: 0.875rem !important;

        .vue-treeselect__placeholder, .vue-treeselect__single-value {
            // line-height: 1.5
        }
    }

    .categories-table {
        height: 75vh;
        font-size: 9pt;

        .categories-table-style-actions {
            min-width: 120px;

            .actions-icons {
                text-align: center;
                white-space: nowrap;
            }
        }

        .categories-table-style-phone {
            min-width: 105px;
        }

        .categories-table-style-th-datetime {
            min-width: 110px;
        }

        .categories-table-style-td-datetime {
            text-align: center;
        }
    }
</style>
